import { CopyMetadataFromParent, Property } from '@skylab-shared/core';
import { VatTableItemModel } from '../vat-table/vat-table-item.model';

@CopyMetadataFromParent()
export class PurchaseVatTableItemModel extends VatTableItemModel {
    @Property()
    public currencyGrossValue?: number;

    @Property()
    public currencyNetValue?: number;

    @Property()
    public currencyVatValue?: number;
}
